<template>
  <div>
    <!-- <div :style="'height:' + footerHeight + 'px'"></div> -->
    <div class="wrap">
      <div class="wrapContent" ref="footer">
        <div class="up">
          <div class="partners item">
            <h3>{{pc_lang.Collaboration_Platform}}</h3>
            <img src="/image/partners.jpg" alt="">
          </div>
          <div class="help">
            <h3>{{pc_lang.Help_center}}</h3>
            <div>
              <a v-for="item in helpList" v-text="item"></a>
            </div>
          </div>
          <div class="customer item">
            <h3>
              <i class="el-icon-service"></i>
              {{pc_lang.Live_CS_}}
            </h3>
            <p>{{pc_lang.Customer_Hotline}}：<span v-if="!!site['service_phone']">{{ site['service_phone']['excel_url'] }}</span></p>
            <p>({{pc_lang.Monday_to_Friday}}：09:00-18:00)</p>
          </div>
        </div>
        <div class="down">
          <div class="left">
            Copyright 2019 pay.egc56.com Inc.All rights reserved.
            <a href="http://beian.miit.gov.cn/" target="blank">粤ICP备18113921号-6</a>
          </div>
          <img src="/image/cz.jpg" alt="">
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Footer',
  data(){
    return {
      helpList: ['Egc56支付','联系我们','用户协议','代购网邦定支付','集运网邦定支付','商城邦定支付'],
      act: 0,
      footerHeight: 0,
      imgList: ['/image/partners.jpg', '/image/cz.jpg']
    }
  },
  computed: {
    ...mapGetters(['site']),
  },
  async mounted() {

  },
  created() {
    // this.setFooterHeight()
  },
  methods: {
    setFooterHeight() {
      /*let a = Promise.all([this.both.imgOnload(this.imgList[0]), this.both.imgOnload(this.imgList[1])]).then((res)=>{
        this.footerHeight = this.$refs.footer.clientHeight
      },(rej)=>{
        console.log('rej', rej)
      })*/
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap{
  width: 100%;
  background: $shortCut;
  /* position: fixed;
  bottom: 0;
  left: 0; */
  // height: 80px;
  .wrapContent{
    width: 1000px;
    font-size: 12px;
    color: #8f8f8f;
    .up{
      width: 100%;
      padding: 40px 0;
      display: flex;
      border-bottom: 1px solid #4b4b4b;
      .item{
        width: 300px;
      }
      .partners{
        margin-right: 60px;
      }
      .help{
        flex: 1;
        padding-right: 50px;
        >div{
          word-break: break-word;
          a{
            display: inline-block;
            margin-right: 12px;
            margin-bottom: 6px;
            font-size: 12px;
            &:hover{
              color: #ccc;
            }
          }
        }
      }
      h3{
        font-size: 14px;
        color: #fff;
        margin-bottom: 12px;
      }
      .customer{
        >h3{
          border: 1px solid #fff;
          display: inline-block;
          padding: 3px 8px;
        }
        >p{
          font-size: 12px;
          margin-bottom: 5px;
          >span{
            color: #3f73da;
          }
        }
      }
    }
    .down{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 25px 0 30px;
    }
  }
}
</style>